import { motion } from 'framer-motion'
import { Link, Navigate } from 'react-router-dom'
import { useParticipant } from '../hooks/useParticipant.js'
import LockedOverlay from '../components/LockedOverlay.jsx'
import LeaderboardRow from '../components/LeaderboardRow.jsx'
import { Reorder } from 'framer-motion'

const FAKE_ROWS = [
  { participant: { id: 'a', name: 'Daisy' }, points: 1240, byDay: [], currentRank: 1 },
  { participant: { id: 'b', name: 'Ollie' }, points: 980, byDay: [], currentRank: 2 },
  { participant: { id: 'c', name: 'Ben' }, points: 720, byDay: [], currentRank: 3 },
  { participant: { id: 'd', name: 'Rebecca' }, points: 410, byDay: [], currentRank: 4 },
  { participant: { id: 'e', name: 'Fred' }, points: 280, byDay: [], currentRank: 5 },
]

export default function Welcome() {
  const { participant, status } = useParticipant()
  if (status === 'loading') return <PageLoader />
  if (participant) return <Navigate to="/" replace />

  return (
    <div className="min-h-screen mesh-bg flex flex-col">
      <header className="px-6 py-4 flex items-center">
        <img src="/climatise-logo.svg" alt="Climatise" className="h-8" />
      </header>

      <div className="flex-1 grid lg:grid-cols-2 gap-10 max-w-6xl w-full mx-auto px-6 pb-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 0.5 }}
        >
          <span className="font-display text-2xl text-brand-blue">Q2 2026</span>
          <h1 className="text-4xl sm:text-5xl font-bold text-brand-text leading-tight mt-1">
            Climatise <br className="hidden sm:block" />LinkedIn league
          </h1>
          <p className="text-lg text-brand-text-muted mt-4 max-w-md">
            £1,750 prize pool. Three months. Whoever pulls the most reach wins.
          </p>

          <ul className="mt-6 space-y-2 text-sm text-brand-text">
            <li className="flex gap-2"><span className="text-brand-blue">→</span> Impressions and engagement tracked for you</li>
            <li className="flex gap-2"><span className="text-brand-blue">→</span> Live leaderboard, badges, streaks</li>
            <li className="flex gap-2"><span className="text-brand-blue">→</span> Weekly digest in Teams</li>
          </ul>

          <Link
            to="/signin"
            className="mt-8 inline-flex items-center gap-2 bg-brand-blue hover:bg-brand-blue-hover text-white text-base font-semibold px-6 py-3.5 rounded-xl shadow-glow-blue transition-colors"
          >
            Sign in →
          </Link>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="hidden lg:block"
        >
          <div className="text-xs uppercase tracking-wider text-brand-text-muted mb-3">What you'll unlock</div>
          <LockedOverlay>
            <Reorder.Group axis="y" values={FAKE_ROWS} onReorder={() => {}} className="space-y-2">
              {FAKE_ROWS.map(r => (
                <LeaderboardRow key={r.participant.id} row={r} />
              ))}
            </Reorder.Group>
          </LockedOverlay>
        </motion.div>
      </div>
    </div>
  )
}

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="flex items-center gap-3">
        <div className="w-3 h-3 rounded-full bg-brand-blue animate-pulse" />
        <span className="text-brand-text-muted text-sm">Loading…</span>
      </div>
    </div>
  )
}
